import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {SnackBarService} from '../../services/snackbar.service';
@Component({
  selector: 'cm-publisher-pixel-tag-new-domain-dialog',
  template: `
    <h3 class="mat-dialog-title">
      <span>{{data.adUnitName}}</span>
    </h3>
    <mat-dialog-content>
      <textarea #foo
                title="Pixel tag"
                class="mat-input-element textarea-note w-100 mb-1"
                [(ngModel)]="data.pixelTag"
                style="height: 200px;"></textarea>
    </mat-dialog-content>
    <mat-dialog-actions class="justify-content-center">
      <button mat-raised-button color="primary" [ngxClipboard]="foo" (cbOnSuccess)="onCopyToClipboard()" class="iconed  mb-3 mb-sm-0">
        <i class="fas fa-clipboard"></i>
        <span>Copy to clipboard</span>
      </button>
      <button mat-raised-button color="" class="mr-1" [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
  `,
})
export class AdUnitPixelTagPreviewDialogComponent {

  constructor(public dialogRef: MatDialogRef<AdUnitPixelTagPreviewDialogComponent>,
              private snackBarService: SnackBarService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onCopyToClipboard() {
    this.snackBarService.success('Copied to clipboard!');
  }
}
